import React, { useState, useEffect, useMemo } from "react";
import CompanyCard from "./CompanyCard";
import useLocation from "../../../hooks/useLocation";
import useAuth from "../../../hooks/useAuth";

// Yardımcı fonksiyon: Fisher-Yates (Knuth) Shuffle
function shuffleArray(array) {
  let currentIndex = array.length,
    randomIndex;
  // While there remain elements to shuffle.
  while (currentIndex !== 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }
  return array;
}

const PopularCompanies = () => {
  const { dealers, fetchDealers, loading, error } = useLocation();
  const { isAuthenticated } = useAuth();
  const [displayedDealers, setDisplayedDealers] = useState([]);

  // Auth durumunu useEffect dışında al
  const isUserAuthenticated = isAuthenticated();

  // 1. Adım: Tüm bayileri çek
  useEffect(() => {
    fetchDealers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Bağımlılık fetchDealers olarak değiştirilebilir, ancak hook stabilse sorun olmaz.

  // 2. Adım: Bayi verisi veya auth durumu değişince filtrele
  useEffect(() => {
    console.log(
      "DisplayedDealers hesaplama efekti çalıştı. Bayi sayısı:",
      dealers?.length,
      "Auth:",
      isUserAuthenticated
    );
    if (dealers && dealers.length > 0) {
      let finalDealers = [];
      let userCityId = null;

      if (isUserAuthenticated) {
        try {
          const userStr = localStorage.getItem("user");
          if (userStr) {
            const userData = JSON.parse(userStr);
            // Kullanıcı verisindeki şehir ID alanı adını kontrol edin (örneğin: city_id, cityId)
            userCityId = userData?.city_id;
            console.log("Kullanıcı Şehir ID:", userCityId);
          }
        } catch (e) {
          console.error("Kullanıcı verisi okunurken hata:", e);
        }
      }

      if (isUserAuthenticated && userCityId) {
        // Giriş yapmış ve şehir ID'si var
        // Bayi verisindeki şehir ID alanı adını kontrol edin (örneğin: city_id, cityId)
        const dealersInCity = dealers.filter(
          (dealer) => dealer.city_id === userCityId
        );
        const dealersOutOfCity = dealers.filter(
          (dealer) => dealer.city_id !== userCityId
        );
        console.log(
          `Şehirdeki bayi sayısı (${userCityId}):`,
          dealersInCity.length
        );

        if (dealersInCity.length >= 12) {
          // Şehirde yeterli bayi var
          finalDealers = shuffleArray([...dealersInCity]).slice(0, 12);
          console.log("Şehirdeki bayilerden 12 tanesi seçildi.");
        } else {
          // Şehirde 12'den az bayi var
          finalDealers = [...dealersInCity]; // Şehirdekilerin hepsini al
          const neededMore = 12 - finalDealers.length;
          if (neededMore > 0 && dealersOutOfCity.length > 0) {
            const randomOutOfCity = shuffleArray([...dealersOutOfCity]).slice(
              0,
              neededMore
            );
            finalDealers = finalDealers.concat(randomOutOfCity);
            console.log(
              `Şehir dışından ${neededMore} bayi eklendi. Toplam: ${finalDealers.length}`
            );
          }
          // Son listeyi karıştır (isteğe bağlı, şehirdekiler başta kalabilir)
          finalDealers = shuffleArray(finalDealers);
        }
      } else {
        // Giriş yapmamış veya şehir ID'si yok
        console.log(
          "Giriş yapılmamış veya şehir ID yok, tüm bayilerden 12 tanesi seçiliyor."
        );
        finalDealers = shuffleArray([...dealers]).slice(0, 12);
      }

      setDisplayedDealers(finalDealers);
    } else {
      setDisplayedDealers([]); // Bayi yoksa veya yüklenmediyse boşalt
    }
    // Bağımlılıklar güncellendi: dealers ve isUserAuthenticated boolean değeri
  }, [dealers, isUserAuthenticated]);

  return (
    <div className="mt-20 px-4">
      <h2 className="text-2xl font-bold text-[#111827] mb-8 text-center">
        En Çok Tercih Edilen Firmalar
      </h2>
      <div className="max-w-[1320px] mx-auto">
        {loading && <p className="text-center text-gray-500">Yükleniyor...</p>}
        {error && <p className="text-center text-red-500">Hata: {error}</p>}
        {!loading && !error && (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {displayedDealers.map((dealer) => (
              <CompanyCard key={dealer.id} dealer={dealer} />
            ))}
          </div>
        )}
        {!loading && !error && displayedDealers.length === 0 && (
          <p className="text-center text-gray-500">
            Gösterilecek bayi bulunamadı.
          </p>
        )}
      </div>
    </div>
  );
};

export default PopularCompanies;
